import FileSelector from '@/components/selectors/FileSelector';
import Editor from '@/components/tiptap/Editor';
import { Card } from '@mui/material';
import { useState } from 'react';

export default function AssignmentItem({ item }) {
  const [files, setFiles] = useState([]);
  console.log(files);
  return (
    <Card
      sx={{
        p: 3,
      }}
    >
      <Editor content={item.content || ''} editable={false} />
      <FileSelector
        multiple={item.multipleFiles}
        types={item.fileTypes}
        onChange={setFiles}
      />
    </Card>
  );
}
